import { breakpoints } from 'theme/MuiThemeProvider/breakpoints';
import { customTheme } from 'theme/MuiThemeProvider/theme';

export const companyChatModalStyles = {
  padding: '20px',
  borderRadius: '10px',
  height: '352px',

  '& .sendbird-conversation__messages': {
    height: '232px',
    maxHeight: '232px',
  },

  '& .sendbird-conversation': {
    borderRadius: '10px',
    overflow: 'hidden',
    border: `1px solid ${customTheme.custom.black.B10}`,
  },

  [`@media (max-width: ${breakpoints.tablet}px)`]: {
    height: '500px',
    padding: '10px',

    '& .sendbird-conversation__messages': {
      height: '388px',
      maxHeight: '388px',
    },

    '& .sendbird-conversation__messages-padding': {
      paddingLeft: '4px',
      paddingRight: '4px',
    },
  },
};
